var commitDate = '2019110311';
(function ($, global, GsBase) {
	'use strict';

	 /** 
     * JBP 브랜드샵 script
     * 
     * 신규작성 - 20180402 chohj, ray0506
     */
    var JbpPrmm = function(){
		this.init();
	};
	
	JbpPrmm.prototype = {

			JBP_BRAND_CD : 0,
			JBP_MAIN_URL :  "/shop/prmm/sect.gs",
			JBP_SRCH_URL :  "/shop/prmm/sectAjax.gs",
			
			jbpData : {},
			familyBrandFst : true, //패밀리브랜드 처음 클릭
			isProgress : false,
			
			layerWrapper : 'jbpLayerWrapper',
			$layerWrapper: {},
			
			noticeHtml : '',
			
			init : function(){
				
				this.initSearch();
				
			},// end function(init)
			
			//검색호출 -
			initSearch : function(){
				var jbpGbn = $('#filter-sort').attr('jbp-gbn');
				if (jbpGbn == 'NEW') { 
					this.JBP_MAIN_URL = "/shop/prmm/newArrival.gs";
					this.JBP_SRCH_URL = "/shop/prmm/newArrivalAjax.gs";
				}

				this.jbpData = $('#band-contents').data();

				if(!this.jbpData) return;

				this.JBP_BRAND_CD = this.jbpData.jbpcd;
				var param = "jbpBrandCd=" +this.JBP_BRAND_CD;

                var currentUrl = document.location.href;
                if(currentUrl.indexOf("grand") > -1){
                    this.JBP_MAIN_URL = "/shop/jbp/grandJbp/sect.gs";

                    var categoryGbn = $('#filter-category').data('gbn');
                    param = param + "&gbn="+categoryGbn;
                }

				if(currentUrl.indexOf("signature") > -1){
					this.JBP_MAIN_URL = "/shop/jbp/signatureJbp/sect.gs";

					var categoryGbn = $('#filter-category').data('gbn');
					param = param + "&gbn="+categoryGbn;
				}

				//검색 script 호출
				Manager.init(this.JBP_MAIN_URL, this.JBP_SRCH_URL, param);
				Filter.jbpBrandShopFlg = true;
				
			}, // end function(initSearch)
			
			//효율실적체크
			dummyLogLink : function(gbn){
				var _lseq = this.LSEQ_DATA[gbn];
				
				GsBase.recordWiselog({"lseq":_lseq});
				
			},//dummyLogLink
			
			callAjax : function( t, url, paramobj, callback ) {
				
				var _this = this;
				
				_this.isProgress = true;
				if ( !_this.$layerWrapper.length ) {
					$('body').append('<div id="'+_this.layerWrapper+'" />');
					_this.$layerWrapper = $('#'+_this.layerWrapper); 
				}
				
				$.ajax({
					url  : url,
					type : 'get',
					data : paramobj
				})
				.done( function( data ) {
					_this.isProgress = false;
//					{"webError":{"requestId":"6ea39e0f-a2ad-4961-ae4b-04f71c530480","errorCode":"BPRDA001","errorMessage":"잘못된 상품 코드 입니다.","exceptionTrace":"iceberg.framework.core.web.servlet.handler.exception.APIException: BPRDA001\n\tat iceberg.capi.product.api.prd.PrdInfoRestController.getCmmShopPrds(PrdInfoRestController.java:303)\n\tat sun.reflect.GeneratedMethodAccessor803.invoke(Unknown Source)\n\tat sun.reflect.DelegatingMethodAccessorImpl.invoke(DelegatingMethodAccessorImpl.java:25)\n\tat java.lang.reflect.Method.invoke(Method.java:597)\n\tat org.springframework.web.method.support.InvocableHandlerMethod.invoke(InvocableHandlerMethod.java:219)\n\tat org.springframework.web.method.support.InvocableHandlerMethod.invokeForRequest(InvocableHandlerMethod.java:132)\n\tat org.springframework.web.servlet.mvc.method.annotation.ServletInvocableHandlerMethod.invokeAndHandle(ServletInvocableHandlerMethod.java:104)\n\tat org.springframework.web.servlet.mvc.method.annotation.RequestMappingHandlerAdapter.invokeHandleMethod(RequestMappingHandlerAdapter.java:745)\n\tat org.springframework.web.servlet.mvc.method.annotation.RequestMappingHandlerAdapter.handleInternal(RequestMappingHandlerAdapter.java:686)\n\tat org.springframework.web.servlet.mvc.method.AbstractHandlerMethodAdapter.handle(AbstractHandlerMethodAdapter.java:80)\n\tat org.springframework.web.servlet.DispatcherServlet.doDispatch(DispatcherServlet.java:925)\n\tat org.springframework.web.servlet.DispatcherServlet.doService(DispatcherServlet.java:856)\n\tat org.springframework.web.servlet.FrameworkServlet.processRequest(FrameworkServlet.java:936)\n\tat org.springframework.web.servlet.FrameworkServlet.doPost(FrameworkServlet.java:838)\n\tat javax.servlet.http.HttpServlet.service(HttpServlet.java:647)\n\tat org.springframework.web.servlet.FrameworkServlet.service(FrameworkServlet.java:812)\n\tat javax.servlet.http.HttpServlet.service(HttpServlet.java:728)\n\tat org.apache.catalina.core.ApplicationFilterChain.internalDoFilter(ApplicationFilterChain.java:305)\n\tat org.apache.catalina.core.ApplicationFilterChain.doFilter(ApplicationFilterChain.java:210)\n\tat org.springframework.web.filter.CharacterEncodingFilter.doFilterInternal(CharacterEncodingFilter.java:88)\n\tat org.springframework.web.filter.OncePerRequestFilter.doFilter(OncePerRequestFilter.java:107)\n\tat org.apache.catalina.core.ApplicationFilterChain.internalDoFilter(ApplicationFilterChain.java:243)\n\tat org.apache.catalina.core.ApplicationFilterChain.doFilter(ApplicationFilterChain.java:210)\n\tat org.apache.catalina.core.StandardWrapperValve.invoke(StandardWrapperValve.java:222)\n\tat org.apache.catalina.core.StandardContextValve.invoke(StandardContextValve.java:123)\n\tat org.apache.catalina.authenticator.AuthenticatorBase.invoke(AuthenticatorBase.java:472)\n\tat org.apache.catalina.valves.AccessLogValve.invoke(AccessLogValve.java:931)\n\tat org.apache.catalina.core.StandardHostValve.invoke(StandardHostValve.java:171)\n\tat org.apache.catalina.valves.ErrorReportValve.invoke(ErrorReportValve.java:99)\n\tat org.apache.catalina.core.StandardEngineValve.invoke(StandardEngineValve.java:118)\n\tat org.apache.catalina.connector.CoyoteAdapter.service(CoyoteAdapter.java:407)\n\tat org.apache.coyote.http11.AbstractHttp11Processor.process(AbstractHttp11Processor.java:1004)\n\tat org.apache.coyote.AbstractProtocol$AbstractConnectionHandler.process(AbstractProtocol.java:589)\n\tat org.apache.tomcat.util.net.JIoEndpoint$SocketProcessor.run(JIoEndpoint.java:310)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.runTask(ThreadPoolExecutor.java:886)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:908)\n\tat java.lang.Thread.run(Thread.java:662)\n","serverIp":null,"serverName":null,"additionalError":{"forwardUrl":null,"forwardUrlLabel":"GS SHOP 메인으로 이동","errorMessageByBiz":null,"errorMessageByBizList":null,"forwardUrlList":null,"forwardUrlLabelList":null,"errorPageTitle":"주문 공통","errorPage":null,"returnUrl":null,"returnUrlParams":null,"actionType":null},"status":406,"develo
					if(!data || data.webError){
						if( t === '#brandStory' || t === '#lookBook' ){
							blindBox(0);
						}
						alert('서비스가 원활하지 않습니다.\n잠시후 다시 시도해 주세요.');
						return;
					}
					
					if( t === '#brandStory' || t === '#lookBook' ){
						
						_this.$layerWrapper.append( data ).css({display:'block'});
						blindBox(1);
						
						setTimeout(function(){
							_this.$layerWrapper.css({visibility:'visible'});
							$(t).itemAlignCenter()
								.fadeTo(200,1);
							
						}, 300);
					
					}
					
					callback(data);
				});

			}, //call ajax
			
	};// end  jbp prototype
	
	$(function() {
		GsBase.JbpPrmm = new JbpPrmm();
	});
	
	//location 
	$.fn.itemAlignCenter = function(){
		return this.each(function(){
			var topBlank = 30;
			var element = $(this);
			var elementHeight = this.offsetHeight || element.outerHeight();
			
			if ( elementHeight + topBlank < $(window).height() ){
				element.css({
					position:'fixed',
					left:'50%',
					top:'50%',
					marginLeft:-element.outerWidth()/2,
					marginTop:-(element.outerHeight()/2) -5,
					zIndex:2500
				});
			} 
			else {
				element.css({
					position:'static',
					display:'inline-block',
					margin: topBlank + 'px auto',
					zIndex:2500
				});
			}
		});
	}
	
}) (jQuery, window, window.GsBase = window.GsBase || {});